import { useQuery } from '@tanstack/react-query';

import { getInsuranceCriteria } from 'services/insurance';

export function useInsuranceCriteria(enabled: boolean) {
  return useQuery({
    queryKey: ['insurance-criteria'],
    queryFn: getInsuranceCriteria,
    enabled,
    // Enrollment changes insurance state outside this app. Revalidate when the
    // entry page mounts so a cached pre-enrollment result cannot persist.
    refetchOnMount: 'always',
  });
}
